const MIN_QUERY_CHARS = 3;

export { MIN_QUERY_CHARS };
